"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useEventCallback = _interopRequireDefault(require("@mui/utils/useEventCallback"));
var _default = exports.default = _useEventCallback.default;